import { withTranslation } from "react-i18next";

import GroupCategoryList from './GroupCategoryList';

export default withTranslation(undefined, { withRef: true })(GroupCategoryList);